import { StatusItem } from "../../mailing-list/models/status-item";
import { ParticipantItem } from "../../mailing-list/models/participantItem";

export class AuctionFilter {

  constructor() { }

  dateAucFrom: string;
  dateAucTo: string;
  dateSubmissionFrom: Date;
  dateSubmissionTo: Date;
  dtFrom: string;
  dtTo: string;

  isNewAuc: number;
  searchMainField: string;

  status: string;
  statusAucLost: number;
  statusAucWin: number;
  statusAucRefusalOfParticipation: number;
  statusAucWorked: number;
  statusAucRejected: number;
  statusAucPreliminaryStudy: number;
  distrMember: string;
  distrWinner: string;
  distrLogist: string;
  contractor: string;
  mnn: string;
  region: string;
  kam: string;
  sumFrom: string;
  sumTo: string;
  email: string;
  search: string;
  amountPosition: boolean;
  addSign: boolean;
  participant: ParticipantItem = new ParticipantItem();
  statusItem: StatusItem = new StatusItem();
  aucAgreementStatus: string;
  federalLaw: string;
  algorithmType: number;
}




// WEBPACK FOOTER //
// ./src/app/modules/home/models/auction-filter.ts